import { useApi } from '@/api';
import { CardList, LinkButton, Link, ListSkeleton } from '@/components';
import {
  CurrencyValue,
  Flex,
  ListItem,
  WalletAddress
} from '@blockanalitica/ui';

export default function TopHolders({ address, ...rest }) {
  const [data, error] = useApi({
    url: `/tokens/${address}/holders/`,
    queryParams: {
      p_size: '3',
      order: '-total_balance'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <CardList
        title="Top Holders"
        action={
          <LinkButton to="holders" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.wallet_address}
              to={`holders/${row.wallet_address}`}>
              <Flex justifyContent="space-between" alignItems="center">
                <WalletAddress address={row.wallet_address} />

                <CurrencyValue
                  value={row.balance}
                  options={{
                    iconSize: '0',
                    currency: { name: data.symbol, address }
                  }}
                />
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
